import { createSelector } from 'reselect'
import getLoyaltyPurchasePointsItems from '../items/getLoyaltyPurchasePointsItems'
import { getLoyaltyPurchasePointsOffersKey } from 'actions/loyalty/fetchLoyaltyPurchasePointsOffers'
import { getCurrentUserId, selectLoggedIn } from 'selectors/accountSelectors'

const getLoyaltyPurchasePointsItemViews = createSelector(
  (state: App.State) => getLoyaltyPurchasePointsItems(state),
  (state: App.State) => state.loyalty.purchaseOffers,
  (state: App.State) => state.geo.currentCurrency,
  (state: App.State) => selectLoggedIn(state) ? getCurrentUserId(state) : undefined,
  (items, purchaseOffers, currency, customerId): App.WithDataStatus<Array<App.Checkout.LoyaltyPurchasePointsItemView>> => {
    const cacheKey = getLoyaltyPurchasePointsOffersKey(currency, customerId)
    // Defensive: in some hot-reload / hydration paths `purchaseOffers` can be undefined
    // before the reducer's `INITIAL_LOYALTY_STATE` is reapplied. Optional chain so the
    // selector returns an empty offer set instead of crashing the totals pipeline.
    const offers = purchaseOffers?.[cacheKey]?.data

    const views = items.map((item): App.Checkout.LoyaltyPurchasePointsItemView => {
      const offer = offers?.find(o => o.id === item.offerId)
      const basePrice = offer?.basePrice ?? item.price
      return {
        title: item.title,
        item,
        basePrice,
        totalPoints: item.points + item.bonusPoints,
        loyalty: {},
        totals: {
          price: item.price,
          memberPrice: 0,
          value: basePrice,
          memberValue: 0,
          surcharge: 0,
          extraGuestSurcharge: 0,
          taxesAndFees: 0,
        },
      }
    })

    return {
      hasRequiredData: true,
      data: views,
    }
  },
)

export default getLoyaltyPurchasePointsItemViews
